import React from "react";

import { Box } from "@mui/material";
import { AddBox, AddToHomeScreen, Android, Apple, IosShare, MoreVert } from "@mui/icons-material";

import useMainState from "../../../../../config/context/mainStateContext";
import { GreyPallet } from "../../../../../config/styles";

export default function DeviceBanner() {
  const { deviceInfo, getOperatingSystem } = useMainState();

  return !deviceInfo?.standalone ? (
    <Box style={{ width: "100%" }} mt={4}>
      <Box style={{ backgroundColor: GreyPallet.Light, borderRadius: 15 }} p={2}>
        {getOperatingSystem() === "iOS" ? (
          <Box>
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} gap={2}>
              <Apple style={{ fontSize: 30 }} />
              <p>Tenha os horários sempre disponível mesmo sem internet:</p>
            </Box>
            <Box
              style={{ backgroundColor: GreyPallet.LightGhost, borderRadius: 15 }}
              py={0.5}
              mt={1}
            >
              <p style={{ color: GreyPallet.Regular, textAlign: "center" }}>
                Acesse através do <span style={{ color: "black" }}>Safari</span>
              </p>
            </Box>
            <Box
              style={{ backgroundColor: GreyPallet.LightGhost, borderRadius: 15 }}
              p={0.5}
              mt={1}
            >
              <p style={{ color: GreyPallet.Regular, textAlign: "center" }}>
                Clique no menu "<IosShare style={{ verticalAlign: "bottom", color: "black" }} />"
              </p>
            </Box>
            <Box
              style={{ backgroundColor: GreyPallet.LightGhost, borderRadius: 15 }}
              p={0.5}
              mt={1}
            >
              <p style={{ color: GreyPallet.Regular, textAlign: "center" }}>
                "Adicionar à Tela de Início
                <AddBox style={{ verticalAlign: "bottom", color: "black", marginLeft: 5 }} />"
              </p>
            </Box>
          </Box>
        ) : (
          <Box>
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} gap={2}>
              <Android style={{ fontSize: 30 }} />
              <p>Tenha os horários sempre disponível mesmo sem internet:</p>
            </Box>
            <Box
              style={{ backgroundColor: GreyPallet.LightGhost, borderRadius: 15 }}
              py={0.5}
              mt={1}
            >
              <p style={{ color: GreyPallet.Regular, textAlign: "center" }}>
                Acesse através do <span style={{ color: "black" }}>Chrome</span>
              </p>
            </Box>
            <Box
              style={{ backgroundColor: GreyPallet.LightGhost, borderRadius: 15 }}
              p={0.5}
              mt={1}
            >
              <p style={{ color: GreyPallet.Regular, textAlign: "center" }}>
                Clique no menu "<MoreVert style={{ verticalAlign: "bottom", color: "black" }} />"
              </p>
            </Box>
            <Box
              style={{ backgroundColor: GreyPallet.LightGhost, borderRadius: 15 }}
              p={0.5}
              mt={1}
            >
              <p style={{ color: GreyPallet.Regular, textAlign: "center" }}>
                "
                <AddToHomeScreen
                  style={{ verticalAlign: "bottom", color: "black", marginLeft: 5 }}
                />{" "}
                Instalar Aplicativo"
              </p>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  ) : null;
}
